import { render, staticRenderFns } from "./PersonDetailsInfo.vue?vue&type=template&id=952a1268&scoped=true&"
import script from "./PersonDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./PersonDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonDetailsInfo.vue?vue&type=style&index=0&id=952a1268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a1268",
  null
  
)

export default component.exports